import i18n from "@/plugins/vue-i18n";

export default {
  namespaced: true,
  state: {
    status: {
      approved: {
        text: i18n.t("dealershipApplications.status.accepted"),
        color: "green",
        value: "approved",
        isViewOnly: true,
      },
      in_progress: {
        text: i18n.t("dealershipApplications.status.inProgress"),
        color: "yellow",
        value: "in_progress",
      },
      rejected: {
        text: i18n.t("dealershipApplications.status.declined"),
        color: "red",
        value: "rejected",
        isViewOnly: true,
      },
      new_for_manager: {
        text: i18n.t("dealershipApplications.status.newForManager"),
        color: "blue",
        value: "new_for_manager",
      },
      approved_added_to_existing: {
        text: i18n.t("dealershipApplications.status.approvedAddedToExisting"),
        color: "green",
        value: "approved_added_to_existing",
        isViewOnly: true,
      },
    },
    filtersForm: null,
  },

  getters: {
    getStatuses(state) {
      return () => {
        return Object.values(state.status);
      };
    },

    getFilters(state) {
      return () => {
        if (!state.filtersForm) {
          return null;
        }

        return Object.entries(state.filtersForm).reduce((filters, [key, value]) => {
          const isFilledArray = Array.isArray(value) && value.length > 0;
          const isFilledValue = value !== "" && value !== null && value !== undefined;

          if (isFilledArray || (!Array.isArray(value) && isFilledValue)) {
            filters[key] = Array.isArray(value) ? [...value] : value;
          }

          return filters;
        }, {});
      };
    },

    getStatus(state) {
      return (status) => {
        return state.status[status];
      };
    },

    isApplicationDetailsViewOnly(state) {
      return (statusKey) => {
        if (!statusKey) {
          return false;
        }

        const meta = state.status[statusKey];

        if (!meta) {
          return false;
        }

        if (meta.isViewOnly) {
          return true;
        }

        return false;
      };
    },
  },

  mutations: {
    SET_FILTERS_FORM(state, form) {
      state.filtersForm = form;
    },
  },
};
